import React from 'react';

import { List } from '../../../components';
import { useRefreshPage } from '../../../hooks/useRefreshPage';
import { ListContainer } from '../../../containers';
import MachineSetupListItem from './MachineSetupListItem';

const MachineSetupList = ({
	items: setups,
	refetch,
	customProps,
	customControls,
}) => {
	const [refreshPage, isRefreshing] = useRefreshPage(refetch);

	return (
		<List
			items={setups}
			listItemComponent={MachineSetupListItem}
			onRefresh={refreshPage}
			isRefreshing={isRefreshing}
			emptyListMessage="No machine setups found"
			autoScrollTop={true}
			showControls={true}
			assembler={[]}
			removeTopMargin={true}
			customProps={customProps}
			customControls={customControls}
		/>
	);
};

export default ListContainer(MachineSetupList);
